export const ERRORS = {
    // AUTH
    EMAIL_REQUIRED: "Email adress is required.",
    USERNAME_REQUIRED: "Username is required.",
    PASSWORD_REQUIRED: "Password is required.",
    INVALID_EMAIL: "Invalid email address.",
    INVALID_PASSWORD: "Password must be at least 8 characters long and contain both letters and numbers.",
    ROLE_REQUIRED: "Role is required.",

    // EMPLOYEE
    NAME_REQUIRED: "Name is required.",
    EMAIL_REQUIRED: "Email is required.",
    PASSWORD_REQUIRED: "Password is required.",


    PHONE_NO_REQUIRED: "Phone number is required.",
    PHONE_NO_LENGTH: "Phone number must contain 10 digits.",
    DATE_REQUIRED: "Date is required.",
    LOCATION_REQUIRED: "Location is required.",
    SALARY_REQUIRED: "Salary is required.",
    DESIGNATION_REQUIRED: "Designation is required.",

    // HOLIDAY
    TYPE_REQUIRED: "Type is required.",

    // LEAVE
    EMPLOYEE_REQUIRED: "Select Employee.",
    BALANCE_REQUIRED: "Balance is required.",
    LEAVE_DAY_REQUIRED: "Leave day is required.",
    REASON_REQUIRED: "Reason is required.",
    HALF_DAY_REQUIRED: "Half day type is required.",

    // ATTENDANCE
    CHECK_IN_REQUIRED: "Check in time is required.",
    CHECK_OUT_REQUIRED: "Check out time is required",

    // DEPARTMENT
    TOTAL_EMPLOYEE_REQUIRED: "Total Employee is required.",

    // BANK_DETAILS
    BRANCH_REQUIRED: "Branch is required.",
    ACCOUNT_NO_REQUIRED: "Account Number is required.",
    IFSC_CODE_REQUIRED: "Ifsc code is required.",

    // DAILY_TASK
    PROJECT_REQUIRED: "Project is required.",
    TASK_REQUIRED: "Task is required",
    NOTE_REQUIRED: "Note is required",

    // META-INFO
    PAGE_REQUIRED: "Page is required",
    META_TITLE_REQUIRED: "Meta title is required",
    META_DESCRIPTION_REQUIRED: "Meta description is required.",

    // FAQ
    QUESTION_REQUIRED: "Question is required.",
    ANSWER_REQUIRED: "Answer is required.",

    // NEWS
    TITLE_REQUIRED: "Title is required",
    IMAGE_REQUIRED: "Image is required.",
    DESCRIPTION_REQUIRED: "Description is required.",
};